// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"704124dc","436":"25451499"}[chunkId] + ".chunk.js";
};